/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type ICompanyActiveSolutionsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type ICompanyActiveSolutionsQuery = {
  __typename?: 'Query';
  activeSoftwareEscrows: { __typename?: 'SoftwareEscrowPage'; nodesCount: number };
  activeBackups: { __typename?: 'BackupPage'; nodesCount: number };
  activeSaasEscrows: { __typename?: 'SaasEscrowPage'; nodesCount: number };
  activeContinuityEscrows: { __typename?: 'ContinuityEscrowPage'; nodesCount: number };
};

export const CompanyActiveSolutionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'companyActiveSolutions' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'activeSoftwareEscrows' },
            name: { kind: 'Name', value: 'softwareEscrows' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'EnumValue', value: 'active' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nodesCount' } }],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'activeBackups' },
            name: { kind: 'Name', value: 'backups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'EnumValue', value: 'active' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nodesCount' } }],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'activeSaasEscrows' },
            name: { kind: 'Name', value: 'saasEscrows' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'EnumValue', value: 'active' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nodesCount' } }],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'activeContinuityEscrows' },
            name: { kind: 'Name', value: 'continuityEscrows' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'EnumValue', value: 'active' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nodesCount' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ICompanyActiveSolutionsQuery, ICompanyActiveSolutionsQueryVariables>;
